module.exports = __webpack_public_path__ + "static/img/轴直角方式斜齿齿条的计算.76051929.jpg";